import { Accept } from "react-dropzone";

/** Config for types accepted by SENEC Website */
export const senecAcceptedTypes: Accept = {
    "image/jpeg": [".jpg"],
    "image/png": [".png"],
    "image/svg+xml": [".svg"],
    "image/heif": [".heif"],
    "image/heif-sequence": [".heifs"],
    "image/heic": [".heic"],
    "image/heic-sequence": [".heics"],
    "image/avif": [".avci", ".avcs", ".avif"],
    "text/plain": [".txt"],
    "application/pdf": [".pdf"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-powerpoint": [".ppt"],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/xml": [".xml"],
    "application/x-tar": [".tar"],
    "application/gzip": [".gz"],
    "application/zip": [".zip"],
    "application/java-archive": [".jar"],
    "application/octet-stream": [".conf"],
};

export const buildAcceptedTypes = (mimeTypes?: string[]): Accept => {
    if (!mimeTypes || mimeTypes.length === 0 || mimeTypes.includes("ALL")) {
        return senecAcceptedTypes;
    }

    const acceptedTypes: Accept = {};
    for (const mimeType of mimeTypes) {
        if (mimeType in senecAcceptedTypes) {
            acceptedTypes[mimeType] = senecAcceptedTypes[mimeType];
        }
    }

    return acceptedTypes;
};

export const getAcceptedTypesFileExtensions = (acceptedTypes: Accept) => {
    let fileExtensions: string[] = [];

    for (const fileExtensionsArray of Object.values(acceptedTypes)) {
        fileExtensions = [...fileExtensions, ...fileExtensionsArray];
    }

    return fileExtensions.join(", ");
};
